// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__13iN2","right":"styles_right__G9lOU"};